module.exports = __webpack_public_path__ + "static/media/Image.94863534.png";